import { TextColors } from '../../components/ui/color-picker/color-picker';
import { Format } from '../../pages/mindmap/use-mindmap-text-formatting';

// returns the text formatting of a HTMLElement
export const getTextFormat = (element: HTMLElement): Format => {
  // background-color needs to be checked for all parent elements
  let activeHighlight: TextColors | undefined = undefined;
  let currentElement = element;
  do {
    const backgroundColor = window.getComputedStyle(currentElement).backgroundColor;
    if (!['rgba(0, 0, 0, 0)', 'var(--surface-0)', 'rgb(255, 255, 255)'].includes(backgroundColor)) {
      activeHighlight = backgroundColor as TextColors;
      break;
    }

    if (currentElement.parentElement) currentElement = currentElement.parentElement;
    else break;
  } while (currentElement && !currentElement.classList.contains('node-text-root'));

  // detect if any parent is a link element
  let link: boolean = false;
  currentElement = element;
  do {
    const isLink = currentElement.nodeName == 'A';
    if (isLink) {
      link = true;
      break;
    }

    if (currentElement.parentElement) currentElement = currentElement.parentElement;
    else break;
  } while (currentElement && !currentElement.classList.contains('node-text-root'));

  const computedStyle = window.getComputedStyle(element);

  let selectedTextFormats: Format = {
    bold: {
      type: 'bold',
      key: 'font-weight',
      set: '700',
      unset: '400',
      value: computedStyle.fontWeight === '700',
    },
    italic: {
      type: 'italic',
      key: 'font-style',
      set: 'italic',
      unset: 'normal',
      value: computedStyle.fontStyle === 'italic',
    },
    size: {
      type: 'size',
      activeFontSize: parseInt(computedStyle.fontSize, 10),
      key: 'font-size',
    },
    light: {
      type: 'light',
      key: 'font-weight',
      set: '100',
      unset: '400',
      value: computedStyle.fontWeight === '100',
    },
    monospace: {
      type: 'monospace',
      key: 'font-family',
      set: 'monospace',
      unset: 'var(--font-family)',
      value: computedStyle.fontFamily === 'monospace',
    },
    color: {
      type: 'color',
      key: 'color',
      unset: 'var(--text-color)',
      activeColor: computedStyle.color as TextColors,
    },
    highlight: {
      type: 'highlight',
      key: 'background-color',
      unset: 'var(--surface-0)',
      activeHighlight,
    },
    link: {
      type: 'link',
      link: link,
    },
  };

  return selectedTextFormats;
};
